<template>
  <div>
    <cashflow-app/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import CashflowApp from './CashflowApp.vue';

export default {
  name: 'DemoCashflowApp',
  components: {
    CashflowApp,
  },

  async created() {
    this.setCustomerDetails({
      firstName: 'אדם',
      secondMemberName: 'חווה',
      numberOfMembers: 2,
      householdName: 'אדם וחווה',
      phoneNumberFromQuery: '',
    });
  },
  methods: {
    ...mapMutations('session', ['setCustomerDetails']),
  },
};
</script>
